module.exports = __webpack_public_path__ + "static/media/moon.b38dcb5d.png";